module.exports = __webpack_public_path__ + "img/ic_arrow_slider_active_Light.929cc8a.svg";